// extracted by mini-css-extract-plugin
export default {"section":"ServicesBanner_section__va+Wu","textPart":"ServicesBanner_textPart__kBDrA","imgPart":"ServicesBanner_imgPart__i442b"};